<template>
    <AnimationWrapper>
        <template #animationContent>
            <div v-if="supportsThumbnailLayout" class="thumbnail-layout-preview" :style="cornerRadiusContainerStyle">
                <ThumbnailImagePreview
                    :thumbnail-data="section.media.thumbnailData"
                    :layouts="thumbnailLayouts"
                    :thumbnail-size="'section'"
                    :project="$store.state.project"
                    :interactive="false"
                    :show-helper-text-override="false"
                />
            </div>
            <template v-else-if="showSingleMockup">
                <div :class="section.media.mockupSettings.mockupType" class="single-mockup-preview" :style="cornerRadiusContainerStyle">
                    <MockupContainer
                        :media="section.media"
                        :scrollable="allowMockupScroll"
                    />
                </div>
            </template>
            <PlaceMediaContent v-else :section="section" :default-caption="defaultCaption" :placeholder-image="placeholderImage" />
        </template>
    </AnimationWrapper>
</template>

<script>
    import PlaceMediaContent from "./PlaceMediaContent.vue";
    import AnimationWrapper from "../../../../common/components/AnimationWrapper.vue";
    import MockupContainer from "@/scripts/common/components/MockupContainer.vue";
    import ThumbnailImagePreview from "@/scripts/common/components/thumbnails/ThumbnailImagePreview.vue";
    import {thumbnailLayouts} from "@/scripts/common/thumbnailLayouts.js";
    import {MockupDisplayModeEnum, SectionTypesEnum} from "@/scripts/common/enums.js";

    export default {
        name: "GetMediaContent",
        components: {ThumbnailImagePreview, MockupContainer, AnimationWrapper, PlaceMediaContent},
        props: ['section', 'defaultCaption', 'placeholderImage'],
        data() {
            return {
                thumbnailLayouts: thumbnailLayouts
            }
        },
        computed: {
            activeMockupDisplayMode() {
                if (this.section?.media?.mockupDisplayMode === MockupDisplayModeEnum.LAYOUT || this.section?.media?.mockupDisplayMode === MockupDisplayModeEnum.DEVICE) {
                    return this.section.media.mockupDisplayMode;
                }
                if (this.section?.media?.thumbnailData && !this.section?.media?.mockupSettings) {
                    return MockupDisplayModeEnum.LAYOUT;
                }
                return MockupDisplayModeEnum.DEVICE;
            },
            supportsThumbnailLayout() {
                return this.section.media.type === 'Image'
                    && !!this.section.media.thumbnailData
                    && this.activeMockupDisplayMode === MockupDisplayModeEnum.LAYOUT
                    && (
                        this.section.type === SectionTypesEnum.MEDIA
                        || this.section.type === SectionTypesEnum.GENERAL
                        || this.section.type === SectionTypesEnum.TEXT_AND_MEDIA
                    );
            },
            showSingleMockup() {
                return this.section.media.type === 'Image'
                    && !!this.section.media.mockupSettings
                    && this.activeMockupDisplayMode !== MockupDisplayModeEnum.LAYOUT;
            },
            cornerRadiusContainerStyle() {
                return {
                    borderRadius: `${this.section?.media?.cornerRadiusPx ?? 0}px`,
                    overflow: 'hidden'
                };
            },
            allowMockupScroll() {
                if (this.section.type === SectionTypesEnum.GALLERY || this.section.type === SectionTypesEnum.TABS) {
                    return this.section.allowScrollInMockup !== false;
                }
                return true;
            }
        }
    }

</script>

<style scoped lang="scss">
.thumbnail-layout-preview {
    width: 100%;
    height: 100%;

    :deep(.background-color-container) {
        width: 100%;
        height: 100%;
    }

    :deep(.thumbnail-preview) {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    :deep(.mockups-container.small) {
        margin: auto;
    }
}

.single-mockup-preview {
    width: 100%;
    height: 100%;
}
</style>
